import { render } from "./IconSignature.vue?vue&type=template&id=6d593c5c"
import script from "./IconSignature.vue?vue&type=script&lang=ts"
export * from "./IconSignature.vue?vue&type=script&lang=ts"
script.render = render

export default script